import Model from "./Model";

export default class TravelInfo extends Model {
    constructor(data) {
        super(data);
    }

    get description_limited() {
        return _.truncate(
            this.get('description'), {
            'length': 300,
        });
    }
}
